module.exports = __webpack_public_path__ + "img/Monte_Kope_DJI_0248.cac6cb66.jpg";